/* import __COLOCATED_TEMPLATE__ from './edit-flow.hbs'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { BITCOIN_TREASURY_ACCOUNT_TYPE } from '@banking/ui/utils/constants';
import { inject as service } from '@ember/service';
import { WithholdingConfig } from '@square/dashboard-protos/models/squareup/banking/withholding_config_model';
import { Owner, OwnerType } from '@square/dashboard-protos/models/squareup/banking/common';
import { select } from '@banking/ui/services/investments-workflow';
import { updateBtcWithholdingConfigRequestAction, setOnboardingScreenAction } from '@banking/ui/workflows/investments';
let InvestmentsEditFlow = (_dec = select(state => state.currentOnboardingScreen), _dec2 = select(state => state.withholdingBps), _dec3 = select(state => state.maxWithholdingBps), _dec4 = select(state => state.isLoading), _dec5 = select(state => state.withholdingConfig), _class = class InvestmentsEditFlow extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _initializerDefineProperty(this, "sentry", _descriptor2, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor3, this);
    _initializerDefineProperty(this, "intl", _descriptor4, this);
    _initializerDefineProperty(this, "features", _descriptor5, this);
    _initializerDefineProperty(this, "investmentsWorkflow", _descriptor6, this);
    _initializerDefineProperty(this, "page", _descriptor7, this);
    _initializerDefineProperty(this, "currentWithholdingBps", _descriptor8, this);
    _defineProperty(this, "withholdingBps", void 0);
    _initializerDefineProperty(this, "maxBps", _descriptor9, this);
    _initializerDefineProperty(this, "isLoading", _descriptor10, this);
    _initializerDefineProperty(this, "withholdingConfig", _descriptor11, this);
    _defineProperty(this, "accountType", BITCOIN_TREASURY_ACCOUNT_TYPE);
    this.withholdingBps = this.currentWithholdingBps;
  }
  closeAndSuccessToast() {
    this.args.close();
    this.marketToasts.success(this.intl.t('banking.investments.toast.amountUpdated'));
  }
  setOnboardingScreen(newPage) {
    this.investmentsWorkflow.emit(setOnboardingScreenAction(newPage, true));
  }
  updateWithholdingConfig() {
    const owner = Owner.create({
      type: OwnerType.MERCHANT,
      id: this.capitalEngineContext.sessionContext.merchantToken
    });
    const withholdingConfig = WithholdingConfig.create({
      ...this.withholdingConfig,
      withholdingBps: this.withholdingBps
    });
    try {
      this.investmentsWorkflow.emit(updateBtcWithholdingConfigRequestAction(owner, withholdingConfig, false));
    } catch (error) {
      this.sentry.captureException(error);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "investmentsWorkflow", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "page", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "currentWithholdingBps", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "maxBps", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "withholdingConfig", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "closeAndSuccessToast", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeAndSuccessToast"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setOnboardingScreen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setOnboardingScreen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateWithholdingConfig", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateWithholdingConfig"), _class.prototype), _class);
export { InvestmentsEditFlow as default };